import { cn } from '@/utils';

type LoaderSize = 'sm' | 'md' | 'lg';

interface LoaderProps {
  className?: string;
  size?: LoaderSize;
}

const sizeClasses: Record<LoaderSize, string> = {
  sm: 'w-[100px] h-[100px]',
  md: 'w-[150px] h-[150px]',
  lg: 'w-[250px] h-[250px]',
};

function Loader({ className, size = 'lg' }: LoaderProps) {
  return (
    <div
      className={cn(
        'fixed z-[100] inset-0 w-full h-full bg-white/50 flex items-center justify-center ',
        className
      )}
    >
      <img src="/images/loader.gif" alt="Loading" className={cn('shrink-0', sizeClasses[size])} />
    </div>
  );
}

export default Loader;
